import gql from 'graphql-tag';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';

const { backend } = clients.direct;

const defaultTransactionFileds = {
  _id: '',
  feeNumber: '',
  feeDescription: '',
  toUnit: '',
};

export const taxFeeMaster = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
    taxFeeMasterData: [],
  }),
  mutations: {
    setTaxFeeMasterData(state, val) {
      state.taxFeeMasterData = val;
    },
  },
  actions: {
    async loadTaxFeeMasterTypes({ commit, dispatch },
      { criteria, baseCrudKey, postProcessTrans }) {
      let results;
      const gqlfields = defaultTransactionFileds;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query taxFeeMasterDetails($criteria:sharedTaxFundTypes){
            taxFeeMasterDetails(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)}
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxFeeMasterDetails } = results.data;
          commit('setTaxFeeMasterData', taxFeeMasterDetails);
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxFeeMasterDetails) : taxFeeMasterDetails;
          // callers that only read state.taxFeeMasterData pass no baseCrudKey; committing
          // with an undefined key adds a bogus entry to base/crud items, which invalidates
          // every computed reading from that collection
          if (baseCrudKey) {
            commit('base/crud/setItems', [baseCrudKey, processedTransData], {
              root: true,
            });
          }
        }
      } catch (error) {
        dispatch('flashError', 'There was a problem getting tax fee Types.', { root: true });
      }
    },
    async upsertFeeMasterTypes({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`
          mutation upsertFeeMasterDetails($item:sharedTaxFundTypes){
            upsertFeeMasterDetails(upsert: $item) {
                ${fieldsToGqlString(defaultTransactionFileds)}
              }
            }
          `,
          variables: {
            item,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const taxFeeMasterStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newFeeMasterType = results.data.upsertFeeMasterDetails;
        const newList = mergeByIdNewAtTop(taxFeeMasterStateData || [], newFeeMasterType);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (error) {
        dispatch('flashError', 'There was a problem getting tax Fee master.', { root: true });
      }
    },
    async upsertImportFeeMaster({ dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        console.info('upsertImportFeeMaster item:', item);
        results = await backend.mutate({
          mutation: gql`
          mutation upsertImportFeeMaster($item:  importFeeMasterInputType){
            upsertImportFeeMaster(upsert: $item) {
               _id,
              feeNumber
              feeDescription
              }
            }
          `,
          variables: {
            item,
          },
          fetchPolicy: 'no-cache',
        });
      } catch (error) {
        dispatch('flashError', 'There was a problem getting tax Fee master.', { root: true });
      }

      return results;
    },
    async importFeeMasterDetails({ dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query importFeeMasterDetails($criteria:importFeeMasterInputType){
            importFeeMasterDetails(criteria: $criteria) {
                feeNumber
                feeDescription
                tag
                _id
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });

        return results.data.importFeeMasterDetails;
      } catch (error) {
        dispatch('flashError', 'There was a problem getting tax fee Types.', { root: true });
      }
      return [];
    },
  },
};

export default taxFeeMaster;
